import React from "react";

const RetireIcon = ({ width, height, color }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.24385 19.3969H19.8014C20.0174 19.3972 20.2296 19.3406 20.4167 19.2328C20.6038 19.125 20.7592 18.9697 20.8672 18.7827C20.9818 18.588 21.0438 18.3668 21.0472 18.1408C21.0506 17.9149 20.9952 17.6919 20.8865 17.4938L11.6064 0.648116C11.5002 0.453029 11.3437 0.289991 11.1531 0.175996C10.9624 0.0620012 10.7447 0.00122416 10.5226 0C10.3005 0.00115382 10.0828 0.0619014 9.89216 0.175904C9.70154 0.289906 9.545 0.452983 9.43889 0.648116L0.160103 17.4931C0.051672 17.6912 -0.00349045 17.9141 1.33514e-05 18.1399C0.00351524 18.3657 0.0655632 18.5867 0.180084 18.7814C0.287619 18.9685 0.442583 19.1239 0.629349 19.2319C0.816114 19.34 1.02808 19.3969 1.24385 19.3969ZM19.1147 17.7316H1.92927L10.522 2.13352L19.1147 17.7316Z"
        fill="white"
      />
      <path
        d="M9.54688 7.87329H11.0469V13.1628H9.54688V7.87329Z"
        fill="white"
      />
      <path
        d="M9.54688 14.2039H11.0469V15.7039H9.54688V14.2039Z"
        fill="white"
      />
    </svg>
  );
};

export default RetireIcon;
